import { useSearchParams } from 'react-router-dom';

import { pick } from 'lodash-es';

export default function useQueryParams(...which: string[]) {
  const [searchParams] = useSearchParams();
  const params = Object.fromEntries(searchParams);

  if (which.length) {
    return which.length === 1 ? params[which[0]] : pick(params, which);
  }

  return params;
}
